"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends3 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _qs = _interopRequireDefault(require("qs"));
var _base = _interopRequireDefault(require("./base"));
var _consts = require("../utils/consts");
var _excluded = ["forSheets", "useCache", "expiration"];
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * `Service` The application service
 */
var Application = /*#__PURE__*/function (_Base) {
  /**
   * Create the project service instance.
   *
   * @param sdk - the SDK instance
   */
  function Application(sdk) {
    var _this;
    (0, _classCallCheck2["default"])(this, Application);
    _this = _callSuper(this, Application, [sdk]);
    _this.acmSessionPromises = {};
    return _this;
  }

  /**
   * Static getter of the class name
   *
   * @returns The detail property name used by SDK instance.
   */
  (0, _inherits2["default"])(Application, _Base);
  return (0, _createClass2["default"])(Application, [{
    key: "getAcmSession",
    value: (
    /**
     * Get acm session with scopes.
     * According to the Apigee team, the session will be stored for 48 hours.
     * And sdk will cache it based on `cacheExpiration` default to half hour.
     *
     * @param scopes - the project scopes to handle permission check.
     * @param config - Configurable object to overwrite request parameters.
     *
     * @returns a promise that resolve with the acm session.
     * @deprecated
     *   The acmSessionId is to be retired and will use scopes in query parameters when passing to DS.
     *   Switch to use DerivativeService if you're trying to get thumbnails or manifest data.
     *   Check https://wiki.autodesk.com/display/R13N/Race+to+AUS%3A+ACM+Namespace
     */
    function () {
      var _getAcmSession = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(scopes, config) {
        var reqScopes, _ref, _ref$forSheets, forSheets, _ref$useCache, useCache, expiration, rest, scopeKey, key, hasCachedKey, acmSession, response;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              reqScopes = scopes && scopes.length > 0 ? {
                'x-ads-acm-scopes': scopes.join(',')
              } : {};
              _ref = config || {}, _ref$forSheets = _ref.forSheets, forSheets = _ref$forSheets === void 0 ? false : _ref$forSheets, _ref$useCache = _ref.useCache, useCache = _ref$useCache === void 0 ? true : _ref$useCache, expiration = _ref.expiration, rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
              scopeKey = reqScopes['x-ads-acm-scopes'] || '';
              key = forSheets ? "acm-session-sheets-".concat(scopeKey) : "acm-session-documents-".concat(scopeKey);
              hasCachedKey = this.Cache.has(key);
              acmSession = this.Cache.get(key);
              if (!(useCache && acmSession)) {
                _context.next = 8;
                break;
              }
              return _context.abrupt("return", acmSession);
            case 8:
              // Clear cached promise if expired
              if (useCache && hasCachedKey && !acmSession) this.acmSessionPromises[key] = undefined;
              if (!useCache || !this.acmSessionPromises[key]) {
                this.acmSessionPromises[key] = this.HttpService.ossExtV2.post('/acmsessions', (0, _extends3["default"])({
                  'x-ads-acm-check-groups': 'true',
                  application: 'autodesk'
                }, reqScopes), rest);
              }
              _context.next = 12;
              return this.acmSessionPromises[key];
            case 12:
              response = _context.sent;
              acmSession = response.data ? response.data.acmsession : null;
              // Refresh Cache data
              this.Cache.set(key, acmSession, expiration);
              return _context.abrupt("return", acmSession);
            case 16:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getAcmSession(_x, _x2) {
        return _getAcmSession.apply(this, arguments);
      }
      return getAcmSession;
    }()
    /**
     * Get pubnub channels from server.
     * For more details, please refer to
     * https://wiki.autodesk.com/pages/viewpage.action?spaceKey=COLLAB&title=BIM+360+Docs+-+Notification+Migration#BIM360Docs-NotificationMigration-5.DocsAPIDefinition
     *
     * @param payload - the channel info
     * @param config - Configurable object to overwrite request parameters.
     * @returns a promise that resolve with the channel id.
     */
    )
  }, {
    key: "getChannels",
    value: (function () {
      var _getChannels = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(payload, config) {
        var res;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.HttpService.dmV1.post("/channels:batch-get", payload, config);
            case 2:
              res = _context2.sent;
              return _context2.abrupt("return", res.data || {});
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getChannels(_x3, _x4) {
        return _getChannels.apply(this, arguments);
      }
      return getChannels;
    }()
    /**
     * Get PubNub channels from sheets service
     *
     * @param projectId -  The project uuid
     * @param params - The query params
     * @param config - Configurable object to overwrite request parameters.
     * @returns Object the channel id
     */
    )
  }, {
    key: "getSheetChannel",
    value: (function () {
      var _getSheetChannel = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(projectId, params, config) {
        var query, _yield$this$HttpServi, data;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              query = _qs["default"].stringify(params, {
                addQueryPrefix: true
              });
              _context3.next = 3;
              return this.HttpService.dmV3.get("/projects/".concat(projectId, "/notification/channel:subscribe").concat(query), config);
            case 3:
              _yield$this$HttpServi = _context3.sent;
              data = _yield$this$HttpServi.data;
              return _context3.abrupt("return", data === null || data === void 0 ? void 0 : data.channelId);
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getSheetChannel(_x5, _x6, _x7) {
        return _getSheetChannel.apply(this, arguments);
      }
      return getSheetChannel;
    }()
    /**
     * Office file viewing token from OFA service
     *
     * @param projectId -  is the project id
     * @param versionUrn - is the document version urn
     * @param payload - is token related payload.
     * @param conf - Configurable object to overwrite request parameters.
     */
    )
  }, {
    key: "getOfficeToken",
    value: (function () {
      var _getOfficeToken = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4(projectId, versionUrn, payload) {
        var _this2 = this;
        var conf,
          config,
          response,
          _args4 = arguments;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              conf = _args4.length > 3 && _args4[3] !== undefined ? _args4[3] : {};
              config = (0, _extends3["default"])((0, _defineProperty2["default"])({}, _consts.CANCEL_KEYS, {
                getter: function getter() {
                  return _this2.officeCancelToken;
                },
                setter: function setter(token) {
                  return _this2.officeCancelToken = token;
                },
                clearer: function clearer() {
                  return _this2.officeCancelToken = undefined;
                }
              }), conf);
              _context4.next = 4;
              return this.HttpService.dmV2.post("/projects/".concat(projectId, "/versions/").concat(encodeURIComponent(versionUrn), "/officeSessions"), payload, config);
            case 4:
              response = _context4.sent;
              return _context4.abrupt("return", response.data);
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function getOfficeToken(_x8, _x9, _x10) {
        return _getOfficeToken.apply(this, arguments);
      }
      return getOfficeToken;
    }()
    /**
     * Get signed url for downloadable resource
     *
     * @param projectId -  is the project id
     * @param downloadId - is the download package id
     * @param payload - is resources to be downloaded.
     * @param config - Configurable object to overwrite request parameters.
     */
    )
  }, {
    key: "getDownloadSignedUrl",
    value: (function () {
      var _getDownloadSignedUrl = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5(projectId, downloadId, payload, config) {
        var url, response;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              url = "/projects/".concat(projectId, "/downloads/").concat(downloadId, "/results/urls");
              _context5.next = 3;
              return this.HttpService.downloadV2.post(url, payload, config);
            case 3:
              response = _context5.sent;
              return _context5.abrupt("return", response.data);
            case 5:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function getDownloadSignedUrl(_x11, _x12, _x13, _x14) {
        return _getDownloadSignedUrl.apply(this, arguments);
      }
      return getDownloadSignedUrl;
    }()
    /**
     * Get system time
     * @param config - Configurable object to overwrite request parameters.
     */
    )
  }, {
    key: "getServerTime",
    value: (function () {
      var _getServerTime = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee6(config) {
        var response, _ref2, currentTime;
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return this.HttpService.dmV3.get('/system', config);
            case 2:
              response = _context6.sent;
              _ref2 = response.data || {}, currentTime = _ref2.currentTime;
              return _context6.abrupt("return", currentTime);
            case 5:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function getServerTime(_x15) {
        return _getServerTime.apply(this, arguments);
      }
      return getServerTime;
    }())
  }], [{
    key: "getName",
    value: function getName() {
      return 'Apps';
    }
  }]);
}(_base["default"]);
var _default = exports["default"] = Application;